import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { LeadTaskType } from "../constants/leadTaskType"
import { FileAttachment } from "@/modules/tasks/customer/models/fileAttachment"
import { LeadTaskStatus } from "@/modules/lead/constants/leadTaskStatus"
import { LeadResponsibleModel } from "@/modules/lead/models/leadResponsibleModel"

@Serializable
export class LeadTaskListView {
  uid: string = ""
  name: string = ""
  customerId: string = ""
  customerName: string = ""
  customerDeadline: string = ""
  created: string = ""
  source: string = ""
  taskType: number = LeadTaskType.NotDefined
  status: number = LeadTaskStatus.NotDefined
  numFiles: number = 0
  isRead: boolean = false

  constructor(
    data: {
      uid: string
      name: string
      customerId: string
      customerName: string
      customerDeadline: string
      created: string
      source: string
      taskType: number
      status: number
      numFiles: number
      isRead: boolean
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.customerId = data.customerId
      this.customerName = data.customerName
      this.customerDeadline = data.customerDeadline
      this.created = data.created
      this.source = data.source
      this.taskType = data.taskType
      this.status = data.status
      this.numFiles = data.numFiles
      this.isRead = data.isRead
    }
  }
}
